import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
// import { AccessErrorComponent } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { AccessErrorComponent } from './access-error.component';

@NgModule({
  declarations: [AccessErrorComponent],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AccessErrorModule { }
